import Alert from "@app/models/alert";

const siteAlertExists = (alerts: Alert[], message: string) => {
  return alerts.filter(siteAlert => siteAlert.message === message).length > 0;
};

export { siteAlertExists };
